/**
 * @fileoverview Shared axios instance with default configuration.
 *
 * Provides a pre-configured axios client with withCredentials, base URL,
 * and a 401 response interceptor that redirects to the landing page on
 * session expiry.
 */

import axios from "axios";

import BACKEND_URL from "./backendUrl";

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Redirect to landing page on 401 (session expired)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !window.location.pathname.match(/^\/$/)) {
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

/**
 * Extract a human-readable error message from an Axios error.
 * Handles FastAPI's 422 validation errors (detail is an array of objects),
 * structured object details (e.g. the consent gate's
 * {code, message, pending_students}), and standard string detail responses.
 */
export function getErrorMessage(error, fallback = "Something went wrong") {
  const detail = error.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg || d.message || JSON.stringify(d)).join(", ");
  if (typeof detail.message === "string") return detail.message;
  return fallback;
}

export default api;
